function remove_item(key) {
  event.preventDefault();
  var data = {
    quantity: 0,
    id: key
  }

  fetch(theme.routes.cartChange, {
    method: "POST",
    body: JSON.stringify(data),
    credentials: "same-origin",
    headers: {
        "Content-Type": "application/json"
    }
  }).then(e => e.json()).then(function(e) {
  if (422 === e.status || "bad_request" === e.status)
  ;
    document.dispatchEvent(new CustomEvent('cart:build'));
  }
  .bind(this));
}

// const cjsNavBtns = document.querySelectorAll('.is-light .swiper-button__icon, .is-light #SiteHeader svg');

// // Store initial styles in dataset attribute
// cjsNavBtns.forEach(navBtn => {
//   navBtn.dataset.initialFill = navBtn.style.fill;
//   navBtn.dataset.initialColor = navBtn.style.color;
// });

// window.addEventListener('scroll', customScrollHandler);

// function customScrollHandler() {
//   const viewportHeight = window.innerHeight;
//   const scrollThreshold = viewportHeight * 0.85;
  
//   if (window.scrollY > scrollThreshold ) {
//     cjsNavBtns.forEach(navBtn => {
//       navBtn.style.fill = '#000000';
//       navBtn.style.color = '#000000';
//     });
//   } else {
//     // Revert back to initial styles
//     cjsNavBtns.forEach(navBtn => {
//       navBtn.style.fill = navBtn.dataset.initialFill;
//       navBtn.style.color = navBtn.dataset.initialColor;
//     });
//   }
// }

